module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_700_ExtraBold.732d3af.woff2";